import React, { useEffect, useMemo, useState } from "react";
import { Accordion } from "react-bootstrap";
import EdButton from "../edbutton/edButton";
import DeviceContext from "../customHooks/indentifyDevice";
import Drawer from "react-bottom-drawer";
import GenericTabs from "../GenericTabs";
import CustomDateFilter from "./CustomDateFilter";
export const updateChecked = (e, filterName, key, setSelected, type) => {
    if (e && filterName && e.target.type === "radio") {
        setSelected((prevState) => {
            return prevState.map((gcFilter) => {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list.map((val) => {
                        if (val.childlist && val.childlist.list) {
                            return val.childlist.list.map((child) => {
                                if (child.key == e.target.value)
                                    child.selected = true;
                                else
                                    child.selected = false;
                            });
                        }
                        else {
                            if (val.key == e.target.value)
                                val.selected = true;
                            else
                                val.selected = false;
                        }
                    });
                }
                return gcFilter;
            });
        });
    }
    else if (e && filterName && e.target.type === "checkbox") {
        setSelected((prevState) => {
            return prevState.map((gcFilter) => {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list[key].selected = e.target.checked;
                }
                return gcFilter;
            });
        });
    }
    else if (type && filterName && type === "tab") {
        setSelected((prevState) => {
            return prevState.map((gcFilter) => {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list.map((x, i) => {
                        if (i === key) {
                            x.selected = true;
                        }
                        else {
                            x.selected = false;
                        }
                    });
                }
                return gcFilter;
            });
        });
    }
};
export const GenericFilter = (props) => {
    const device = DeviceContext();
    const [customSelect, setcustomSelect] = useState(false);
    const [selected, setSelected] = React.useState(props.selectedFilters);
    const [activeKey, setActiveKey] = React.useState(props.defaultActiveKey ? props.defaultActiveKey : props.links[0].eventKey);
    const totalCounts = useMemo(() => {
        let count = 0;
        selected === null || selected === void 0 ? void 0 : selected.map((x) => {
            var _a, _b;
            ((_a = x.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                ((_b = x.list) === null || _b === void 0 ? void 0 : _b.map((z) => {
                    if (z.selected)
                        count++;
                }));
        });
        return count;
    }, [selected]);
    useEffect(() => {
        if (props.defaultActiveKey)
            setActiveKey(props.defaultActiveKey);
    }, [props.defaultActiveKey]);
    useEffect(() => {
        setSelected(props.selectedFilters);
    }, [props.selectedFilters]);
    const EachFilter = (eachFilterprops) => {
        var _a;
        return (React.createElement("div", { id: "filter-show-hide", className: "filterasset-drop-body" },
            React.createElement("ul", { className: "bodylist me-3", id: "asset" },
                React.createElement("div", { className: `d-flex mb-2 ${(eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.clear) && (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.selectAll)
                        ? "justify-content-between align-items-center"
                        : "justify-content-end"}` },
                    (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.selectAll) &&
                        eachFilterprops.selectedType === "checkbox" && (React.createElement("li", { className: "d-flex inside-list align-items-center common-checkbox-custom mb-0" },
                        React.createElement("input", { type: eachFilterprops.selectedType, onChange: (e) => {
                                selectedAllHandler(e, eachFilterprops.filterName);
                            }, checked: eachFilterprops.list.every((x) => x.selected), name: eachFilterprops.propertyKey, value: "Select All" }),
                        React.createElement("label", { className: "bodylist-title DMSan_14_500 txt_primaryGrey" }, "Select All"))),
                    (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.clear) && (React.createElement("div", { className: "" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: eachFilterprops.selectedType === "radio"
                                ? "Clear Selection"
                                : "Clear All", className: "dm-fam", onClick: () => clearSectionWise(eachFilterprops.filterName) })))),
                ((_a = eachFilterprops.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                    eachFilterprops.list.map((val, idx) => {
                        return (React.createElement(React.Fragment, null,
                            React.createElement("div", { key: idx },
                                React.createElement("li", { className: "d-flex inside-list align-items-center common-checkbox-custom " },
                                    React.createElement("input", { type: eachFilterprops.selectedType, onChange: (e) => {
                                            updateChecked(e, eachFilterprops.filterName, idx, setSelected);
                                        }, name: eachFilterprops.propertyKey, value: val.key, checked: val.selected, onClick: () => {
                                            {
                                                val.customDateFilter ? setcustomSelect(true) : "";
                                            }
                                        } }),
                                    React.createElement("label", { className: "bodylist-title DMSan_14_500 txt_primaryGrey" }, val.title)),
                                customSelect ? (React.createElement(React.Fragment, null, val.customDateFilter && (React.createElement(CustomDateFilter, { customDateFilter: props === null || props === void 0 ? void 0 : props.customDateFilter, applyDate: (data) => {
                                        props === null || props === void 0 ? void 0 : props.setCustomDateFilter(data);
                                    } })))) : (""))));
                    }))));
    };
    const selectedAllHandler = (e, filterName) => {
        if (e && filterName && e.target.type === "checkbox") {
            setSelected((prevState) => {
                return prevState.map((gcFilter) => {
                    if (gcFilter.filterName === filterName) {
                        gcFilter.list.map((x) => {
                            x.selected = e.target.checked;
                        });
                    }
                    return gcFilter;
                });
            });
        }
    };
    const clearSectionWise = (filterName) => {
        setSelected((prevState) => {
            return prevState.map((gcFilter) => {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list.map((val) => {
                        val.selected = false;
                        if (val.childlist && val.childlist.list) {
                            return val.childlist.list.map((child) => {
                                child.selected = false;
                            });
                        }
                    });
                }
                return gcFilter;
            });
        });
    };
    // const updateChecked = (
    //   e: React.ChangeEvent<HTMLInputElement>,
    //   filterName: string,
    //   key?: string | number
    // ) => {
    //   setSelected((ui: IFilters[]) => {
    //     let newUIUpdate = JSON.parse(JSON.stringify(ui));
    //     const updateIndex = ui.findIndex(
    //       (x: IFilters) => x.filterName === filterName
    //     );
    //     if (updateIndex > -1) {
    //       newUIUpdate[updateIndex].list = newUIUpdate[updateIndex].list.map(
    //         (x: IFilterList, k: number) => {
    //           if (key === k) {
    //             return { ...x, selected: e.target.checked };
    //           }
    //           return x;
    //         }
    //       );
    //     }
    //     return newUIUpdate;
    //   });
    // };
    const ClearAll = () => {
        props.setSelectedFilters(JSON.parse(JSON.stringify(props.links)));
        setSelected(props.links);
        props.setOpenFilter(false);
    };
    useEffect(() => {
        if (props.defaultActiveKey)
            setActiveKey(props.defaultActiveKey);
        if (props.selectedFilters)
            setSelected(props.selectedFilters);
    }, [props.defaultActiveKey, props.selectedFilters]);
    return (React.createElement(React.Fragment, null, props.openFilter ? (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isMobile) ? (React.createElement(React.Fragment, null,
        React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: () => props.setOpenFilter(false), isVisible: props.openFilter, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
            React.createElement("div", { className: `mob-filterasset-drop funds-filter ${props.externalClassName}` },
                React.createElement("div", { className: "mob-filterasset-drop-head" },
                    React.createElement("div", { className: "down-bar container" },
                        React.createElement("span", { className: "down-bar-left" }, "Filters"),
                        React.createElement("input", { className: "down-bar-right", type: "button", value: "Clear All", onClick: () => ClearAll() }))),
                React.createElement("div", { className: "mob-filterasset-drop-body" }, (selected === null || selected === void 0 ? void 0 : selected.length) > 0 &&
                    (selected === null || selected === void 0 ? void 0 : selected.map((ele, idx) => {
                        var _a, _b, _c;
                        let count = 0;
                        ((_a = ele.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                            ((_b = ele.list) === null || _b === void 0 ? void 0 : _b.map((l) => {
                                if (l.selected)
                                    count++;
                            }));
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Accordion, { className: "main filter-accordion", 
                                //activeKey={ele.eventKey === selected[0].eventKey}
                                key: idx },
                                React.createElement(Accordion.Header, null,
                                    ele.filterName,
                                    React.createElement("span", { className: "color_blue" },
                                        "\u00A0 (",
                                        count,
                                        ")")),
                                React.createElement(Accordion.Body, null, ((_c = ele.list) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                                    (ele.selectType === "tab" ? (React.createElement(GenericTabs, { defaultActiveKey: ele.list[0].key, tabsArray: ele.list.map((x) => {
                                            var _a;
                                            return {
                                                title: x.title,
                                                eventKey: x.key,
                                                tabContent: (React.createElement(EachFilter, { list: x.childlist.list, filterName: x.childlist.filterName, propertyKey: x.childlist.eventKey, selectedType: x.childlist.selectType, clear: (_a = x === null || x === void 0 ? void 0 : x.childlist) === null || _a === void 0 ? void 0 : _a.clear })),
                                            };
                                        }), callBackFunction: (key) => {
                                            let index = null;
                                            ele.list.filter((x, idx) => x.key == key ? (index = idx) : null);
                                            updateChecked(null, ele.filterName, index, setSelected, "tab");
                                        } })) : (React.createElement(EachFilter, { list: ele.list, filterName: ele.filterName, propertyKey: ele.eventKey, selectedType: ele.selectType, clear: ele === null || ele === void 0 ? void 0 : ele.clear })))))));
                    }))),
                React.createElement("div", { className: "mob-filterasset-drop-footer funds-footer" },
                    React.createElement("div", { className: "funds filterasset-drop-footer" },
                        React.createElement(EdButton
                        // className={
                        //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                        //     ? "filter-button-disable"
                        //     : "filter-button aply-btn"
                        // }
                        , { 
                            // className={
                            //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                            //     ? "filter-button-disable"
                            //     : "filter-button aply-btn"
                            // }
                            className: "filter-button aply-btn", value: "Apply", onClick: () => {
                                props.setSelectedFilters(selected);
                                props.setOpenFilter(false);
                            }, btnTyp: "blue-one" }))))))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `filterasset-drop DMSan_16_700 txt_blackOne1 ${props.externalClassName}` },
            "Filters by",
            React.createElement("span", { className: "txt-midnight-blue" },
                "\u00A0(",
                totalCounts,
                ")"),
            (selected === null || selected === void 0 ? void 0 : selected.length) > 0 &&
                (selected === null || selected === void 0 ? void 0 : selected.map((ele, idx) => {
                    var _a, _b, _c;
                    let count = 0;
                    ((_a = ele === null || ele === void 0 ? void 0 : ele.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        ((_b = ele === null || ele === void 0 ? void 0 : ele.list) === null || _b === void 0 ? void 0 : _b.map((l) => {
                            if (l.selected)
                                count++;
                        }));
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Accordion, { className: "filter-accordion", key: idx },
                            React.createElement(Accordion.Header, null,
                                ele.filterName,
                                React.createElement("span", { className: "color_blue" },
                                    "\u00A0 (",
                                    count,
                                    ")")),
                            React.createElement(Accordion.Body, null, ((_c = ele.list) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                                (ele.selectType === "tab" ? (React.createElement(GenericTabs, { defaultActiveKey: ele.list[0].key, tabsArray: ele.list.map((x) => {
                                        var _a;
                                        return {
                                            title: x.title,
                                            eventKey: x.key,
                                            tabContent: (React.createElement(EachFilter, { list: x.childlist.list, filterName: x.childlist.filterName, propertyKey: x.childlist.eventKey, selectedType: x.childlist.selectType, clear: (_a = x === null || x === void 0 ? void 0 : x.childlist) === null || _a === void 0 ? void 0 : _a.clear })),
                                        };
                                    }), callBackFunction: (key) => {
                                        let index = null;
                                        ele.list.filter((x, idx) => x.key == key ? (index = idx) : null);
                                        updateChecked(null, ele.filterName, index, setSelected, "tab");
                                    } })) : (React.createElement(EachFilter, { list: ele.list, filterName: ele.filterName, propertyKey: ele.eventKey, selectedType: ele.selectType, clear: ele === null || ele === void 0 ? void 0 : ele.clear, selectAll: ele === null || ele === void 0 ? void 0 : ele.selectAll })))))));
                })),
            React.createElement("div", { className: "funds filterasset-drop-footer" },
                React.createElement(EdButton, { className: "filter-button clear_all", value: "Clear All", onClick: ClearAll, btnTyp: "blue-one" }),
                React.createElement(EdButton
                // className={
                //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                //     ? "filter-button-disable"
                //     : "filter-button aply-btn"
                // }
                , { 
                    // className={
                    //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                    //     ? "filter-button-disable"
                    //     : "filter-button aply-btn"
                    // }
                    className: "filter-button aply-btn", value: "Apply", onClick: () => {
                        props.setSelectedFilters(selected);
                        props.setOpenFilter(false);
                    }, btnTyp: "blue-one" }))))))) : ("")));
};
